import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { BasketItemComponentDef } from '@df/basket/view/basket-item.component.def';
import { IProductDataV3 } from '@df/catalog/product/product';
import { ImageModule } from '@df/module-image/image.module';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalProduct } from '../../catalog/model/product/product.decorator';
import { LpWishlistToggleComponent } from '../../catalog/ui/product/wishlist/lp-wishlist-toggle.component';
import { LocalBasketItem } from '../../customer/basket/basket-item.decorator';
import { ActionComponent } from '../../ui/api/action.component';
import { ItemQtyComponent } from '../item-qty.component';

@Component({
    selector: 'basket-add-notice-item',
    templateUrl: './basket-add-notice-item.html',
    standalone: true,
    imports: [
        ActionComponent,
        ImageModule,
        ItemQtyComponent,
        LpWishlistToggleComponent,
        NgClass,
        OptionLabelPipe,
        PriceComponent,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketAddNoticeItemComponent extends BasketItemComponentDef<LocalBasketItem> {
    @Output()
    productRemoved = new EventEmitter<void>();
    removeFromBasket() {
        return this.remove().then(() => this.productRemoved.emit());
    }

    declare product?: LocalProduct<IProductDataV3>;

    get image(): string | undefined {
        return (
            this.item!.data!.am_giftcard_image_url ||
            this.product?.data?.image ||
            (this.product?.data?.media && this.product.data.media[0]?.image)
        );
    }
}
